import { useQuery } from '@tanstack/react-query';
import { getCustomBlogs } from '@/services/api/customBlogApi';
import { normalizeBlogPost, BlogPost } from '@/types/blogTypes';

export const useRecentBlogs = (currentBlogId?: number | string, limit: number = 3) => {
  return useQuery({
    queryKey: ['recent-blogs', currentBlogId, limit],
    queryFn: async () => {
      // Fetch more than limit to ensure we have enough after filtering
      // We fetch limit + 2 to account for potentially filtering out the current blog
      const response = await getCustomBlogs(1, limit + 2);

      // Transform the API results to our internal BlogPost type
      const transformedBlogs = response.results.map(normalizeBlogPost);

      // Filter out the current blog (if ID is provided) and limit the results
      const filteredBlogs = transformedBlogs
        .filter((blog: BlogPost) => blog.id !== currentBlogId)
        .slice(0, limit);

      return filteredBlogs;
    },
    enabled: true, // Always enable to show recent blogs
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};